import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/theme-blue.css";
import React from "react";
import PropTypes from "prop-types";

import { AgGridReact } from "ag-grid-react";
import { LicenseManager } from "ag-grid-enterprise/main";

import "./aggrid.css";

LicenseManager.setLicenseKey(
  "Ecological_Information_Management_System_EIMS_2Devs28_July_2018__MTUzMjczMjQwMDAwMA==c1bd39e0db1ded4f3603fbd07733ca4e"
);

const AgGridWrapper = ({
  recordCount,
  storeGridRef,
  showGridColumnPicker,
  actions,
  gridRef,
  getColumnDefs
}) => {
  const gridApi = gridRef.api;
  const resizeCols = () => gridApi && gridApi.sizeColumnsToFit();

  return (
    <div
      className="ag-blue"
      style={{
        width: "100%",
        height: window.innerHeight - 100,
        minHeight: "500px"
      }}
    >
      <AgGridReact
        // debug
        gridOptions={{
          allowContextMenuWithControlKey: true,
          getContextMenuItems: () => ["copy", "copyWithHeaders"]
        }}
        datasource={{
          rowCount: null, // behave as infinite scroll
          getRows: p => {
            actions.fetchPreview(p);
          }
        }}
        rowModelType="infinite"
        cacheBlockSize={100}
        showToolPanel={showGridColumnPicker}
        toolPanelSuppressRowGroups
        toolPanelSuppressValues
        toolPanelSuppressSideButtons
        toolPanelSuppressPivots
        toolPanelSuppressPivotMode
        enableRangeSelection
        suppressColumnMoveAnimation
        rowHeight={30}
        enableColResize
        columnDefs={getColumnDefs()}
        enableSorting
        enableServerSideSorting
        onDisplayedColumnsChanged={resizeCols}
        onGridSizeChanged={resizeCols}
        infiniteInitialRowCount={recordCount}
        onGridReady={params => storeGridRef(params)}
      />
    </div>
  );
};
AgGridWrapper.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  gridRef: PropTypes.object.isRequired,
  showGridColumnPicker: PropTypes.bool.isRequired,
  recordCount: PropTypes.number.isRequired,
  storeGridRef: PropTypes.func.isRequired,
  getColumnDefs: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    fetchPreview: PropTypes.func.isRequired,
    advRemove: PropTypes.func.isRequired,
    setViewChanged: PropTypes.func.isRequired
  }).isRequired
};
export default AgGridWrapper;
